import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { useOnboarding } from '@/pages/Onboarding/context';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { GENDER_OPTIONS } from './constants';
import {
  ContentOverlayStyles,
  GenderIconStyles,
  GradientBorderStyles,
  ImageHalfStyles,
  ImagesContainerStyles,
  OptionsContainerStyles,
  OptionStyles,
  ScreenStyles,
  TitleStyles,
} from './Gender.styles';

const ASSETS_PATH = `${S3_BUCKET_URL}/layout-own-ai-multigender-forest/gender`;

export const ScreenGender: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Gender',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  const handleSelect = (selectedGender: LayoutDataType['gender']) => {
    form.setValue('gender', selectedGender);
    userService.createOrUpdate({
      onboarding_data: {
        gender: selectedGender,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <ScreenStyles background="dark-solid">
      <IonContent scrollY={false}>
        <ImagesContainerStyles>
          <ImageHalfStyles side="left">
            <img src={`${ASSETS_PATH}/forest-female.jpg`} alt="Female" />
          </ImageHalfStyles>
          <ImageHalfStyles side="right">
            <img src={`${ASSETS_PATH}/forest-male.jpg`} alt="Male" />
          </ImageHalfStyles>
        </ImagesContainerStyles>

        <ContentOverlayStyles>
          <TitleStyles>
            Who will walk the wild paths
            <br />
            with you?
          </TitleStyles>

          <OptionsContainerStyles>
            {GENDER_OPTIONS.map((option) => (
              <OptionStyles
                key={option.id}
                isSelected={gender === option.id}
                onClick={() => handleSelect(option.id)}
              >
                <GenderIconStyles gender={option.id!}>
                  <option.Icon />
                </GenderIconStyles>
                <UiTypography variant="title-medium">
                  {option.name}
                </UiTypography>
                <UiTypography variant="body-medium">
                  {option.subtitle}
                </UiTypography>
              </OptionStyles>
            ))}
          </OptionsContainerStyles>
        </ContentOverlayStyles>

        <GradientBorderStyles />
      </IonContent>
    </ScreenStyles>
  );
};
